<template>
  <div class="top-bnr">
    <h1>Where in the world ?</h1>
    <button @click="swit" class="switch">
      <img v-if="darkMode" src="./assets/moonb.svg" alt="" /><img
        v-else
        src="./assets/moon.svg"
        alt=""
      />
      Dark Mode
    </button>
  </div>
  <router-view :darkMode="darkMode" :key="$route.fullPath" />
</template>
<script>
export default {
  data() {
    return {
      darkMode: JSON.parse(localStorage.getItem("darkMode")),
      body: document.querySelector("body"),
    };
  },
  methods: {
    swit() {
      if (this.darkMode) {
        localStorage.setItem("darkMode", false);
      } else {
        localStorage.setItem("darkMode", true);
      }
      this.darkMode = JSON.parse(localStorage.getItem("darkMode"));
    },
  },

  beforeUpdate() {
    if (this.darkMode) {
      this.body.classList.add("Dark");
    } else {
      this.body.classList.remove("Dark");
    }
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;600;700&display=swap");
@import "style/style.scss";
</style>
